import { render } from "./leave_user.vue?vue&type=template&id=13672dab"
import script from "./leave_user.vue?vue&type=script&lang=js"
export * from "./leave_user.vue?vue&type=script&lang=js"

import "./leave_user.vue?vue&type=style&index=0&id=13672dab&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__